export default "__VITE_ASSET__DxMn4tYk__"